module.exports = __webpack_public_path__ + "img/spain.de89af00.svg";